import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMe } from "@/api/queries/auth";
import type { Client } from "@/api/schemas";
import { urlParaCambioDeCliente } from "@/utils/clienteUrl";

/**
 * Cambia de cliente a la misma sección del nuevo, con `push` (que «Atrás» vuelva al anterior).
 * Si hay un formulario sin guardar, `UnsavedChangesGuard` intercepta la navegación.
 */
export function useCambioDeCliente(): (cliente: Client) => void {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: me } = useMe();
  const rol = me?.principal.role;
  return useCallback(
    (cliente: Client) => {
      if (!rol) return;
      const destino = urlParaCambioDeCliente({ pathname: location.pathname, search: location.search, nuevoSlug: cliente.slug, rol });
      navigate(destino);
    },
    [navigate, location.pathname, location.search, rol],
  );
}
